/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".date-box[_ngcontent-%COMP%]{max-width:6em}.subreservation[_ngcontent-%COMP%]{margin-bottom:1rem;padding:20px;background-color:#f7f7f7;box-shadow:0 2px 4px rgba(0,0,0,.15)}.total-price[_ngcontent-%COMP%]{font-size:1.2em}"];
export { styles as styles };
